/* pers-platnosci.js — przenosi pasek metod płatności pod przycisk „Dodaj do koszyka".

   Sekcja motywu renderuje się jako rodzeństwo sekcji produktowej, a przycisk CTA
   siedzi w środku tej drugiej — w pliku współdzielonym i nietykalnym. Przenosimy
   więc WŁASNY węzeł, utworzony przez naszą sekcję. Węzły motywu zostają nietknięte.

   Bez obserwatora: przycisk jest markupem serwerowym (inaczej niż kalkulator,
   który wstrzykuje aplikacja), więc przy `defer` już istnieje.

   Nie dotykamy formularza, nie wołamy submit, nie czytamy ani nie zapisujemy pól. */

(function () {
  'use strict';

  var pasek = document.getElementById('pers-platnosci');
  if (!pasek) return;

  var przycisk = document.querySelector('#main-product .product-form__submit');
  if (!przycisk) return;

  // BEZPOŚREDNIO za przyciskiem, nie na końcu kontenera.
  //
  // Pierwsza wersja robiła `appendChild` na `.product-form__inner` i pasek
  // lądował niżej, niż miał. Powód widać dopiero w źródle sekcji: zaraz za
  // przyciskiem stoi
  //
  //     {%- if block.settings.show_dynamic_checkout -%}{{ form | payment_button }}{%- endif -%}
  //
  // czyli przyciski płatności ekspresowej (Shop Pay, Apple Pay). `appendChild`
  // wstawia na KONIEC kontenera, więc pasek trafiał pod nie zamiast pod CTA.
  //
  // `insertAdjacentElement` przenosi WYŁĄCZNIE nasz węzeł i ustawia go jako
  // rodzeństwo przycisku — układ motywu zostaje nietknięty.
  // Blok „Dodatkowe informacje" pod przyciskiem — opcjonalnie.
  //
  // Docelowa kolejność na karcie auta: CTA -> dodatkowe informacje -> płatności.
  // Blok informacyjny renderuje się w motywie WYŻEJ niż formularz (jest
  // rodzeństwem `.quantity__and__basket` wewnątrz `.product__info-panel`),
  // więc bez przeniesienia stoi nad kalkulatorem.
  //
  // DLACZEGO WOLNO GO PRZENIEŚĆ. Sprawdzone w `section-main-product.css`:
  // wszystkie jego reguły są zaczepione o `#main-product` albo o
  // `.grid__with__calculator` — czyli o PRZODKÓW, nie o bezpośredniego rodzica.
  // Żadna nie używa kombinatora dziecka od `.product__info-panel`, więc węzeł
  // zachowuje wygląd w każdym miejscu wewnątrz `#main-product`.
  //
  // DLACZEGO TUTAJ, A NIE W NAKŁADCE. Obie wstawki celują w to samo miejsce
  // (`afterend` przycisku), a nakładka montuje się później, bo czeka na
  // kalkulator. Dwa skrypty ustawiające sąsiadów tego samego węzła dałyby
  // kolejność zależną od tego, który zdąży pierwszy. Jeden właściciel
  // kolejności = jeden wynik, zawsze ten sam.
  var info = pasek.dataset.podDodatkowymi === 'true'
    ? document.querySelector('#main-product .additional__information__wrapper')
    : null;

  if (info) {
    przycisk.insertAdjacentElement('afterend', info);
    info.insertAdjacentElement('afterend', pasek);
  } else {
    przycisk.insertAdjacentElement('afterend', pasek);
  }
  pasek.hidden = false;
})();
